import _extends from "@swc/helpers/src/_extends.mjs";
import React, { Suspense, lazy, useState, useEffect } from 'react';
import ErrorBoundary from '../../ErrorBoundary';
import LoadingIndicator from '../../LoadingIndicator';
import retry from '../../utils/webpack/chunkRetry';
const MediaSelector = /*#__PURE__*/ lazy(()=>retry(()=>import(/* webpackChunkName: "mediaPopup", webpackPrefetch: true */ './MediaManager.connected')));
export const LoadableMediaManager = (props)=>{
    const [mounted, setMounted] = useState(false);
    useEffect(()=>{
        setMounted(true);
    }, []);
    const waitForMount = typeof window === 'undefined' && !mounted;
    if (waitForMount) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(ErrorBoundary, {
        debugComponent: "LoadableMediaManager"
    }, /*#__PURE__*/ React.createElement(Suspense, {
        fallback: /*#__PURE__*/ React.createElement(LoadingIndicator, {
            view: 'spinner',
            coverMode: true
        })
    }, /*#__PURE__*/ React.createElement(MediaSelector, _extends({}, props))));
};
LoadableMediaManager.displayName = 'LoadableMediaManager';
export default LoadableMediaManager;
